// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   UNAUTHORIZED ACCESS COMPONENT
   ============================================ */

.unauthorized-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  padding: 2rem;
  background-color: var(--background-light);
  animation: fadeIn 0.4s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.unauthorized-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 400px;
  width: 100%;
  padding: 3rem 2rem;
  background-color: var(--surface-light);
  border-radius: 12px;
  border: 1px solid var(--border-light);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.unauthorized-icon {
  font-size: 96px;
  color: var(--error-text);
  margin-bottom: 1.5rem;
  animation: iconPulse 0.6s ease-out;
}

@keyframes iconPulse {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.unauthorized-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 1rem 0;
  line-height: 1.2;
}

.unauthorized-message {
  font-size: 1rem;
  color: var(--text-secondary);
  line-height: 1.6;
  margin: 0 0 2rem 0;
}

.unauthorized-retry-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 32px;
  background-color: var(--primary);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 6px rgba(242, 92, 36, 0.2);
}

.unauthorized-retry-btn:hover {
  background-color: var(--primary-hover);
  box-shadow: 0 6px 8px rgba(242, 92, 36, 0.25);
  transform: translateY(-1px);
}

.unauthorized-retry-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(242, 92, 36, 0.2);
}

/* ============================================
   RESPONSIVE
   ============================================ */
@media (max-width: 400px) {
  .unauthorized-container {
    padding: 1rem;
  }

  .unauthorized-content {
    padding: 2rem 1.5rem;
  }

  .unauthorized-icon {
    font-size: 72px;
  }

  .unauthorized-title {
    font-size: 1.5rem;
  }

  .unauthorized-message {
    font-size: 0.9375rem;
  }

  .unauthorized-retry-btn {
    width: 100%;
    padding: 12px 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/UnauthorizedAccess.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;;iDAEiD;AACjD;EACE;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":["/* ============================================\n   UNAUTHORIZED ACCESS COMPONENT\n   ============================================ */\n\n.unauthorized-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  width: 100%;\n  padding: 2rem;\n  background-color: var(--background-light);\n  animation: fadeIn 0.4s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.unauthorized-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  max-width: 400px;\n  width: 100%;\n  padding: 3rem 2rem;\n  background-color: var(--surface-light);\n  border-radius: 12px;\n  border: 1px solid var(--border-light);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n}\n\n.unauthorized-icon {\n  font-size: 96px;\n  color: var(--error-text);\n  margin-bottom: 1.5rem;\n  animation: iconPulse 0.6s ease-out;\n}\n\n@keyframes iconPulse {\n  0% {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.unauthorized-title {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 1rem 0;\n  line-height: 1.2;\n}\n\n.unauthorized-message {\n  font-size: 1rem;\n  color: var(--text-secondary);\n  line-height: 1.6;\n  margin: 0 0 2rem 0;\n}\n\n.unauthorized-retry-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 32px;\n  background-color: var(--primary);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 600;\n  font-family: 'Inter', sans-serif;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 6px rgba(242, 92, 36, 0.2);\n}\n\n.unauthorized-retry-btn:hover {\n  background-color: var(--primary-hover);\n  box-shadow: 0 6px 8px rgba(242, 92, 36, 0.25);\n  transform: translateY(-1px);\n}\n\n.unauthorized-retry-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 4px rgba(242, 92, 36, 0.2);\n}\n\n/* ============================================\n   RESPONSIVE\n   ============================================ */\n@media (max-width: 400px) {\n  .unauthorized-container {\n    padding: 1rem;\n  }\n\n  .unauthorized-content {\n    padding: 2rem 1.5rem;\n  }\n\n  .unauthorized-icon {\n    font-size: 72px;\n  }\n\n  .unauthorized-title {\n    font-size: 1.5rem;\n  }\n\n  .unauthorized-message {\n    font-size: 0.9375rem;\n  }\n\n  .unauthorized-retry-btn {\n    width: 100%;\n    padding: 12px 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
